import { useState } from "react";
import VehicleSearch from "../../components/VehicleSearch";
import ReconRequestModal from "../../components/ReconRequestModal";
import ReconRequestsViewModal from "../../components/ReconRequestsViewModal";
import { ChangeLocationModal } from "../../components/modals/ChangeLocationModal";
import { useQueryClient } from "@tanstack/react-query";
import type { Vehicle } from "../../types/vehicle";

interface ExtendedVehicle extends Vehicle {
  vehicle_trim?: string;
  mileage?: string | number;
  age_calculated?: number;
  vehicle_status?: string;
  vehicle_sub_status?: string;
  // Flat stage fields from /inventory/search/
  stage?: string | null;
  stage2?: string | null;
  stage3?: string | null;
  // Recon note fields from /inventory/search/
  recon_note?: string | null;
  recon_note_user?: string | null;
  recon_note_updated_at?: string | null;
}

const VehicleCard = () => {
  const [editingVehicle, setEditingVehicle] = useState<ExtendedVehicle | null>(null);
  const [reconRequestVehicle, setReconRequestVehicle] = useState<ExtendedVehicle | null>(null);
  const [viewingReconRequests, setViewingReconRequests] = useState<{ vehicle: ExtendedVehicle } | null>(null);
  const queryClient = useQueryClient();

  const handleLocationChange = () => {
    if (editingVehicle?.vin) {
      queryClient.invalidateQueries({
        queryKey: ["vehicleSearch"],
      });
      queryClient.invalidateQueries({
        queryKey: ["vehicle", editingVehicle.vin],
      });
    }
  };

  return (
    <>
      <VehicleSearch
        setEditingVehicle={setEditingVehicle}
        setReconRequestVehicle={setReconRequestVehicle}
        setViewingReconRequests={setViewingReconRequests}
      />

      {editingVehicle && (
        <ChangeLocationModal
          vehicle={editingVehicle}
          open={!!editingVehicle}
          onOpenChange={(open) => {
            if (!open) setEditingVehicle(null);
          }}
          onSuccess={() => {
            handleLocationChange();
            setEditingVehicle(null);
          }}
        />
      )}

      <ReconRequestModal
        vehicle={reconRequestVehicle || { vin: "", vehicle_inventory_id: "" }}
        open={!!reconRequestVehicle}
        onClose={() => setReconRequestVehicle(null)}
        onSuccess={(results) => {
          console.log("✅ Recon requests created:", results);
        }}
      />

      {viewingReconRequests && (
        <ReconRequestsViewModal
          vehicle={viewingReconRequests.vehicle}
          onClose={() => setViewingReconRequests(null)}
        />
      )}
    </>
  );
};

export default VehicleCard;
